import React, { useEffect, useId, useMemo, useState } from 'react';
import { usePayment } from './script';
import m from './imgs/orange-money.png';
import mWebp from './imgs/orange-money.webp';
import './../../../css/user-menu/Modal.css';

export const CardModal = ({
  translate,
  language,
  minAmount,
  provider,
  triggerSrc,
  triggerSrcWebp,
  triggerSrcAvif,
  triggerAlt = 'Payment',
}) => {
  const amountFieldId = useId();
  const sources = useMemo(() => {
    const png = triggerSrc ?? m;
    const webp = triggerSrcWebp ?? (triggerSrc ? null : mWebp);
    return {
      avif: triggerSrcAvif ?? null,
      webp,
      png,
    };
  }, [triggerSrc, triggerSrcWebp, triggerSrcAvif]);

  const [shouldLoadTrigger, setShouldLoadTrigger] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const warmUp = () => {
      if (!cancelled) setShouldLoadTrigger(true);
    };

    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      // Даём странице отрисоваться — и только потом подгружаем иконку.
      // eslint-disable-next-line no-undef
      const id = requestIdleCallback(warmUp, { timeout: 1200 });
      return () => {
        cancelled = true;
        // eslint-disable-next-line no-undef
        if (typeof cancelIdleCallback !== 'undefined') cancelIdleCallback(id);
      };
    }

    const t = window.setTimeout(warmUp, 400);
    return () => {
      cancelled = true;
      window.clearTimeout(t);
    };
  }, []);
  const {
    modal,
    amount,
    errMsg,
    apiError,
    state,
    handleChangeInput,
    pay,
  } = usePayment({ provider, minAmount });

  return (
    <div>
      <button
        className="user-profile-form-btn"
        onClick={state}
        onMouseEnter={() => setShouldLoadTrigger(true)}
        onFocus={() => setShouldLoadTrigger(true)}
      >
        {shouldLoadTrigger ? (
          <picture>
            {sources.avif ? <source srcSet={sources.avif} type="image/avif" /> : null}
            {sources.webp ? <source srcSet={sources.webp} type="image/webp" /> : null}
            <img
              src={sources.png}
              alt={triggerAlt}
              width={150}
              height={48}
              decoding="async"
            />
          </picture>
        ) : (
          <span
            aria-label={triggerAlt}
            style={{
              display: 'block',
              width: 150,
              height: 48,
              borderRadius: 8,
              background: 'rgba(0,0,0,0.06)',
            }}
          />
        )}
      </button>
      {modal && (
        <div className="modal-window">
          <div className="error-block">
            <div className="error-massage">
              <div className="block-to-flex-column">
                <label htmlFor={amountFieldId}>Amount:</label>
                <input id={amountFieldId} type="text" value={amount} onChange={handleChangeInput} />
                {errMsg && <span>Not a number or not capable number for payment</span>}
                {apiError && (
                  <span role="alert" className="payment-modal-api-error">
                    {apiError}
                  </span>
                )}
              </div>
              <button type="button" className="error-btn" onClick={pay}>
                PAY
              </button>
              <button type="button" className="error-btn" onClick={state}>
                {translate.prase20[language]}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
